var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 181,
    viewBox: "0 0 296 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 181,
    fill: "#BCBABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.25 93.5C162.148 93.5 164.5 91.1484 164.5 88.25C164.5 85.3516 162.148 83 159.25 83C156.352 83 154 85.3516 154 88.25C154 91.1484 156.352 93.5 159.25 93.5Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.438 76H125.562C123.856 76 122.5 77.3891 122.5 79.0953V114.905C122.5 116.611 123.856 118 125.562 118H168.438C170.144 118 171.5 116.611 171.5 114.905V79.0953C171.5 77.3891 170.144 76 168.438 76ZM157.161 97.6234C156.833 97.2406 156.33 96.9453 155.761 96.9453C155.203 96.9453 154.809 97.2078 154.361 97.5688L152.316 99.2969C151.889 99.6031 151.55 99.8109 151.058 99.8109C150.588 99.8109 150.161 99.6359 149.855 99.3625C149.745 99.2641 149.548 99.0781 149.384 98.9141L143.5 92.5484C143.062 92.0453 142.406 91.7281 141.673 91.7281C140.941 91.7281 140.263 92.0891 139.836 92.5813L126 109.272V80.7797C126.109 80.0359 126.689 79.5 127.433 79.5H166.556C167.311 79.5 167.923 80.0578 167.967 80.8125L168 109.294L157.161 97.6234Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/ImagePlaceholder.ae87bde2bbde225bfab1044712d29ab0.svg";
export { ForwardRef as ReactComponent };